export const Mark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g stroke="#FF6A13" strokeWidth="3.2" strokeLinecap="round">
      {[...Array(9)].map((_, i) => {
        const a = (Math.PI * (200 + i * 17.5)) / 180;
        return <line key={i} x1={40 + Math.cos(a) * 15} y1={22 + Math.sin(a) * 15} x2={40 + Math.cos(a) * 21} y2={22 + Math.sin(a) * 21} />;
      })}
    </g>
    <circle cx="40" cy="22" r="11" fill="#FFB020" />
    <path d="M6 30 L42 30 L36 52 L0 52 Z" fill="#1E2AA8" stroke="#fff" strokeWidth="2.4" strokeLinejoin="round" />
    <path d="M18 30 L12 52 M30 30 L24 52 M3 41 L39 41" stroke="#fff" strokeWidth="1.8" />
    <path d="M18 52 L18 60 M12 60 L24 60" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ className = "h-12 sm:h-14" }) => (
  <img src="/img/logo-rsilva-branca.png" alt="RSilva Aquecimento Solar e Bombas" className={`${className} w-auto`} data-testid="brand-logo" />
);
